import moment from "moment"
import React from "react"
import DayPickerInput from "react-day-picker/DayPickerInput"
import { Button } from "semantic-ui-react"


const formatDate = date => {
  return moment(date).format("DD. MMMM YYYY")
}

const DeliveryDatePicker = ({ onChange, date }) => {
  const MIN_DELAY = 0
  return <div className={"pb3"}>
    <div>
      {date && <div>{moment(date, "DD.MM.YYYY").format("dddd, DD. MMMM YYYY")}</div>}
    </div>
    <div className="flex pb3">
    <DayPickerInput
      style={{ zIndex: "999" }}
      value={date}
      placeholder={translate("Sofort")}
      formatDate={formatDate}
      dayPickerProps={{
        initialMonth: moment().add(MIN_DELAY, "day").toDate(),
        disabledDays: [
          {
            before: moment().add(MIN_DELAY, "day").toDate()
          }
        ]
      }}
      onDayChange={onChange} />
    {date && <div className="dib pl3"><Button compact icon="close" onClick={() => onChange("")} />
    </div>}
    </div><div>{translate("LieferterminAbweichung")}</div>
  </div>
}

export default DeliveryDatePicker


// WEBPACK FOOTER //
// ./src/theme/mags/components/Date/DeliveryDatePicker.js